var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconXRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 3.333c9.192 0 16.667 7.477 16.667 16.667 0 9.19-7.475 16.666-16.667 16.666-9.19 0-16.667-7.476-16.667-16.666C3.333 10.81 10.81 3.333 20 3.333z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.483 23.42l-2.965-2.964 2.963-2.963c.57-.568.57-1.493 0-2.062a1.453 1.453 0 00-2.061-.001l-2.965 2.963-2.965-2.967a1.462 1.462 0 00-2.064 0 1.462 1.462 0 000 2.064l2.967 2.966-2.96 2.959c-.57.57-.57 1.495 0 2.061.285.287.657.429 1.03.429a1.45 1.45 0 001.032-.427l2.96-2.96 2.966 2.965a1.46 1.46 0 002.062 0c.57-.57.57-1.493 0-2.063z",
    fill: "#ED1B2E"
  })));
}

export default SvgIconXRed;